<template>
  <div :class="['waiting',isActive ? 'active':'','theme_'+appData.SETTINGS.theme_name]" 
        @click="onScreenClick" id="waiting1">
    

    <div class="globalPopup" v-if="isShowSelectorMode">
        <div class="gpInner">
            <div>
                <div class="gpTitle">Select products:</div>
                <!-- {{appData.SECTIONS}} -->
                <!-- show = {{appData.SECTIONS[0].show}} -->                
                <draggable 
                    tag="transition-group"
                    @start="dragging = true"
                    @end="dragging = false"
                    name="flip-list" 
                    class="gpList" 
                    v-model="appData.SECTIONS" 
                    :options="dragOptions" 
                    item-key="id">                    
                        <div v-for="item in appData.SECTIONS"
                            :class="['gpBox',item.show == 'true' ? 'active':'']"
                            @click="handleItem(item)" :key="item.name">
                            <div>
                                <img class="goLogo" v-if="item.menu_logo.length>0" :src="item.menu_logo+'?V='+appData.SETTINGS.version" />
                                <div class="goTitle" v-else>
                                    {{item.name}}
                                </div>
                            </div>
                        </div>                        
                </draggable>

                <div @click="onNextScreen" 
                    :class="['btnContinue','waitText',numOfShownItems>0 ? 'act':'']">
                    Continue</div>
            </div>
        </div>
    </div>



    <div class="waitElements">
        <div class="waitLogo">
            <img :src="'themes/'+appData.SETTINGS.theme_name+'/images/mainscreen_logo.svg'" /> 
        </div>
        <div class="waitText">{{localize('start')}}</div>
    </div>    
    
    <!--
    <div v-if="appData.SETTINGS.disclamer" class="disc">
        <span>{{appData.SETTINGS.disclamer}}</span>
    </div>
    -->
  </div>
</template>

<style scoped>

.chosen {
  transform: scale(1.1);
  z-index: 20;
  transition: transform 0.2s ease;
}
.ghost
{
    opacity: 1;
    background: #08142a;
}

/* Items that move to make space */
.flip-list-move {
  transition: transform 0.25s ease;
  /* You can also add a small shift */
}
/* Optional: Add styles for entering/leaving elements if needed */
.flip-list-enter-active,
.flip-list-leave-active {
    transition: all 0.3s ease;
}
.flip-list-enter, 
.flip-list-leave-to 
{
    opacity: 0;
    transform: translateY(30px); /* Example: slide down on enter/leave */
}

    .waiting
    {
        font-family: Arial, Helvetica, sans-serif;
    }
    .waiting.theme_ds
    {
        font-family: "Montserrat", sans-serif !important;
    }

    .waiting
    {
        width: 100vw;
        height: 100vh;
        display: flex;
        align-content: center;
        align-items: center;
        opacity: 0;
        transition: all ease 0.5s;
    }
    .waiting.active
    {
        opacity: 1;
    }
    .waiting .waitElements
    {
        color: #fff;
        margin: auto;
        text-align: center;
    }
    .waitLogo
    {
        padding-bottom: 2vw;
    }
    .waitLogo img
    {
        width: 350px;
        height: auto;
    }

    /* DS Theme specific styles */
    .waiting.theme_ds .waitLogo img
    {
        width: 16vw;padding: 1vw 0px;
    }

    .waitText
    {
        text-align: center;
        /* background-image: linear-gradient( 0deg, rgb(90,172,229) 0%, rgb(4,85,151) 79%); */
        border: solid 2px #fff;
        border-radius: 40px;
        padding: 14px 20px;
        text-transform: uppercase;
        width: auto;
        font-size: 0.8vw;
        display: inline;
    }

    .disc
    {
        position: fixed;
        bottom: 5vw;
        width: 600px;
        text-align: center;
        margin: auto;
        left: 50%;
        transform: translateX(-50%);
    }
    .disc span
    {
        text-align: center;
        margin: auto;
        color: #fff;
        font-size: 13px;

    }




    .globalPopup
    {
        position: fixed;
        z-index: 1000;
        width: 100vw;
        height: 100%;
        top: 0px;
        left: 0px;
        display: flex;
        align-items: center;
    }
    .globalPopup .gpInner
    {
        margin: auto;
        align-self: center;
        width: 40vw;
        height: auto;
        min-height: 400px;
        background: #08142a;
        color:#fff;
        border-radius: 25px;
        display: flex;
        align-items: center;
        align-content: center;
    }
    .globalPopup .gpInner > div
    {
        margin: auto;
        text-align: center;
    }
    .gpTitle
    {
        font-size: 20px;
    }
    .gpList____
    {
        padding: 20px 0px;
    }
    .gpList
    {
        list-style: none;
        display: grid;
        grid-template-columns: auto auto auto;
        margin: 0px;
        padding: 30px 0px 40px 0px;
        
    }
    .gpList .gpBox
    {
        width: auto;
        height: 6vw;
        border: solid 1px #fff;
        color: #fff;
        font-size: 10px;
        margin: 5px;
        border: solid 1px rgba(255,255,255,0.2);
        display: flex;
        align-items: center;
        width: 10vw;
        text-align: center;
        transition: all ease 0.3s;
        will-change: transform;
    }
    .gpList .gpBox > div
    {
        width: 100%;
        text-align: center;
    }
    .goLogo
    {
        width: auto;
        height: 20px;
        margin: auto;
        display: inline-block;
        opacity: 0.5;
        transition: all ease 0.3s;
    }
    .goTitle
    {
        font-size: 13px;
        width: 80%;
        margin: auto;
        opacity: 0.5;
        transition: all ease 0.3s;
    }
    .gpBox.active
    {
        border: solid 1px rgba(255,255,255,1);
    }
    .gpBox.active .goLogo
    {
        opacity: 1;
    }
    .gpBox.active .goTitle
    {
        opacity: 1;
    }

    .btnContinue
    {
        opacity: 0.3;
    }
    .btnContinue.act
    {
        opacity: 1;
    }

    @media only screen and (max-width: 820px) {
        .waiting.theme_ds .waitLogo img 
        {
            width: 40vw;
            padding-bottom: 30px;
            FONT-WEIGHT: 200;
        }        
        .waitText
        {
            font-size: 15px;
        }
        .globalPopup .gpInner
        {
            width: 90vw;
            min-height: 650px;
        }
        .gpList{
            grid-template-columns: auto auto;
            margin: 0px;
            padding: 30px 0px 40px 0px;
            width: 70vw;
            grid-column-gap: 20px;
        }        
        .gpList .gpBox
        {
            height: 20vw;width: 100%;
        }
        .btnContinue
        {
            font-size: 16px;
        }
    }



    /* VERTICAL OLED SCREEN */
    @media only screen and (min-device-width: 601px) 
            and (max-device-width: 3024px) 
            and (orientation: portrait)
    {
        .waitText
        {
            border-radius: 40px;
            padding: 16px 30px;
            font-size: clamp(20px,1vw,40px);
            display: inline;
        }        
        .waiting.theme_ds .waitLogo img{
            width: 30vw;
            padding: 4vw 0px;
        } 
        .globalPopup .gpInner
        {
            width: 60vw;
            height: auto;
            min-height: 500px;
            border-radius: 25px;
            border: solid 1px #fff;
        }        
        .gpList .gpBox
        {
            width: 14vw;
            height: 8vw;
        }               
    }    

</style>

<script>
    import { mapState, mapGetters, mapActions } from "vuex";
    import draggable from "vuedraggable";

    //import Screen from "@/components/Screen.vue";
    export default 
    {
        components:{draggable},
        computed:
        {
            ...mapState(["appData","appThemeData"]),
            isShowSelectorMode()
            {
                return this.appData.SETTINGS.canSelectSections === 'true';                
                //return this.appData.SETTINGS.app_id.indexOf("global")>-1;
            },
            numOfShownItems()
            {
                return this.appData.SECTIONS.filter(item => item.show === "true").length;
            },
            dragOptions() {
                return {
                    animation: 200,
                    ghostClass: "ghost",
                    chosenClass: "chosen",                    
                    swap: true,           // enable real-time swap animation
                    swapThreshold: 0.65,
                    distance: 5   
                    //forceFallback: true    // ensures smooth grid sliding
                }
            }
        },
        data()
        {
            return{
                dragging: false,
                showGlobalPopup:false,
                isActive:true
            }
        },
        mounted()
        {
            var vm = this;
            window.onresize = function() {
                vm.setScreenHeight();
            };
            vm.setScreenHeight();
            if(this.isShowSelectorMode){
                this.showGlobalPopup=true;
            }
        },
        created()
        {
            this.setScreenHeight();
        },
        methods:
        {        
            onNextScreen()
            {
                if(this.numOfShownItems>0){                    
                    this.showGlobalPopup=false;//close the popup
                }
            },
            handleItem(item)
            {
                if (!this.dragging) {
                    this.toggleItem(item);
                }
            },
            toggleItem(item)
            {
                item.show = item.show == "false" ? "true":"false";
            },
            localize(tag)
            {
                let tagText = tag.toLowerCase().replace(/(\s|-)/g, "_");
                let obj = this.appData.UI.find(({ tag }) => tag === tagText);
                if (obj) {return obj.title;}
                return tag;
            },
            setScreenHeight()
            {                
                if(window.innerWidth<1000)
                {
                    let waitingScreenElement = document.getElementById("waiting1");
                    if(waitingScreenElement){
                        waitingScreenElement.style.height = window.innerHeight + "px";
                    }                
                }
            },
            onScreenClick()
            {
                if(this.showGlobalPopup){
                    return false;//wait until user selected sections from popup
                }
                //close screen and open menu
                this.isActive = false;
                setTimeout(() => {
                    this.$emit('onClick');    
                }, 800);                
            }
        }
    };
</script>